// contact-form.js — eADR contact form: validation, char counter, submit, reset

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const MSG_MAX  = 1000;

export function initContactForm() {
  const form    = document.getElementById('contact-form');
  if (!form) return;   // not on the contact page

  const nameEl    = document.getElementById('contact-name');
  const emailEl   = document.getElementById('contact-email');
  const msgEl     = document.getElementById('contact-message');
  const termsEl   = document.getElementById('terms');
  const privacyEl = document.getElementById('privacy');
  const submitBtn = document.getElementById('contact-submit');
  const charCount = document.getElementById('char-count');
  const successEl = document.getElementById('contact-success');
  const resetBtn  = document.getElementById('contact-reset');

  // ── Inline error element (created once, appended to actions row) ─────────
  const actionsEl = form.querySelector('.contact-form__actions');
  const errorEl   = document.createElement('p');
  errorEl.className = 'contact-form__error';
  errorEl.setAttribute('role', 'alert');
  errorEl.hidden = true;
  if (actionsEl) actionsEl.insertAdjacentElement('afterend', errorEl);

  // ── Validation ────────────────────────────────────────────────────────────
  function validate() {
    const ok =
      nameEl.value.trim() !== '' &&
      EMAIL_RE.test(emailEl.value.trim()) &&
      msgEl.value.trim() !== '' &&
      termsEl.checked &&
      privacyEl.checked;

    submitBtn.disabled = !ok;
    return ok;
  }

  // ── Char counter ──────────────────────────────────────────────────────────
  function updateCharCount() {
    const remaining = MSG_MAX - msgEl.value.length;
    if (charCount) charCount.textContent = remaining + '/' + MSG_MAX;
  }

  // ── Show / hide error ─────────────────────────────────────────────────────
  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  function clearError() {
    errorEl.textContent = '';
    errorEl.hidden = true;
  }

  // ── Show success panel ────────────────────────────────────────────────────
  function showSuccess() {
    form.hidden = true;
    if (successEl) {
      // reveal using the same pattern as scroll-animations.js
      successEl.classList.remove('animate-in-hidden');
      successEl.classList.remove('contact-success');
      successEl.hidden = false;
      successEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // ── Reset to initial state ────────────────────────────────────────────────
  function resetForm() {
    form.reset();
    updateCharCount();
    clearError();
    validate();

    form.hidden = false;
    if (successEl) {
      successEl.classList.add('animate-in-hidden');
      successEl.hidden = true;
    }
  }

  // ── Event listeners ───────────────────────────────────────────────────────
  [nameEl, emailEl, termsEl, privacyEl].forEach(el => {
    el.addEventListener('input',  validate);
    el.addEventListener('change', validate);
  });

  msgEl.addEventListener('input', () => {
    updateCharCount();
    validate();
  });

  if (resetBtn) resetBtn.addEventListener('click', resetForm);

  // ── Submit ────────────────────────────────────────────────────────────────
  let submitting = false;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (submitting || !validate()) return;

    submitting = true;
    submitBtn.disabled = true;
    clearError();

    const websiteEl = document.getElementById('contact-website'); // honeypot

    const body = new URLSearchParams({
      name:    nameEl.value.trim(),
      email:   emailEl.value.trim(),
      message: msgEl.value.trim(),
      terms:   termsEl.checked   ? '1' : '',
      privacy: privacyEl.checked ? '1' : '',
      website: websiteEl ? websiteEl.value : '',
    });

    try {
      const res  = await fetch(form.action, {
        method:  'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body:    body.toString(),
      });

      const data = await res.json().catch(() => ({ message: '' }));

      if (res.ok) {
        showSuccess();
      } else {
        showError(data.message || 'Error');
        submitBtn.disabled = false;
      }
    } catch (_err) {
      showError('Network error. Please try again.');
      submitBtn.disabled = false;
    } finally {
      submitting = false;
    }
  });

  // ── Init ──────────────────────────────────────────────────────────────────
  updateCharCount();
  validate();
}
